var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn-remove",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.$emit('click')}}},[_c('i',{staticClass:"icon icon-times"})])
}
var staticRenderFns = []

export { render, staticRenderFns }